import { timePickerDefaultProps } from '@zoryn/components/time-picker'
import { buildProps, definePropType } from '@zoryn/utils'

import type { ExtractPropTypes, ExtractPublicPropTypes } from 'vue'
import type { DatePickerType } from '@zoryn/components/date-picker-panel/src/types'

export const datePickerProps = buildProps({
  ...timePickerDefaultProps,
  /**
   * @description type of the picker
   */
  type: {
    type: definePropType<DatePickerType>(String),
    default: 'date',
  },
} as const)

export type DatePickerProps = ExtractPropTypes<typeof datePickerProps>
export type DatePickerPropsPublic = ExtractPublicPropTypes<
  typeof datePickerProps
>
